<template>
  <!-- act-list .al -->
  <div class="al">
    <filterCommon3 @select="select"></filterCommon3>
    <actItem :topic="topic"></actItem>
  </div>
</template>

<script>
import filterCommon3 from "@components/filter-common3/filter-common3.vue";
import actItem from "./components/act-item.vue";
export default {
  name: "act-list",
  data() {
    return {
      topic: -1, // -4：免费报名，-3：新发布，-2：热搜，-1:所有，0:Normal=不置顶，1:Hot=热门，2:Recommend=推荐"
    };
  },
  components: { filterCommon3, actItem },
  computed: {},
  methods: {
    select(type){
      switch(type){
        case '全部':
          this.topic = -1;
          break;
        case '热门':
          this.topic = 1;
          break;
        case '最新发布':
          this.topic = -3;
          break;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.al {
  
}
</style>
